import Notify from "toastr";

Notify.options.timeOut = 2500;
Notify.options.positionClass = "toast-top-center";

export default Notify;
